import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Injectable } from '@angular/core';
import { Role } from 'src/userRoles/userRoles';


@Injectable({
  providedIn: 'root',
})
export class UserroleService {
  private _role: string;
  userRoles: any;

  public get role(): string {
    return this._role;
  }

  constructor(private authenticationService: AuthenticationService) { }

  // checkAuthorityRolePrevilidges() {
  //   let role = this.assignRoleType();
  //   if (role === Role.Authority
  //     //&& to do : add condition for valid authority
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }


  roleTypeForMenu(rolevalue: any) {
    if (rolevalue == "authority_admin" || rolevalue == "authority") {
      return Role.Authority;
    } else if (rolevalue == "provider" || rolevalue =="provider_admin") {
      return Role.Provider;
    } else if (rolevalue == "admin" || rolevalue == "supporter") {
      return Role.Administrator;
    }
    else
    return "none";
  }

  isAdmin(rolevalue: any)
  {
    if (rolevalue == "admin" ) {
      return Role.Kombit_administrator;
    }
    else{
      return Role.Kombit_supporter;
    }
  }

}
